import React from 'react';
import Switch from 'react-router-dom/Switch';
import Redirect from 'react-router-dom/Redirect';
import CheckAuthorization from './CheckAuthorization';
import LoginPage from './container/LoginPage';
import LogoutPage from './container/LogoutPage';
import PasswordForgottenPage from './container/PasswordForgottenPage';
import ReportsPage from './container/ReportsPage';
import RequestReportPage from './container/RequestReportPage';
import RequestReportsListPage from './container/RequestReportsListPage';
import NotFoundPage from './container/404Page';
import AdminUsersPage from './container/AdminUsersPage';
import AdminUserFormPage from './container/AdminUserForm';
import BaseLayout from './layout/Base';
import AdminLayout from './layout/Admin';
import SimpleLayout from './layout/Simple';
import './App.css';

export const PAGE_GENERAL = {
    Root: '/',
    Login: '/login',
    Logout: '/logout',
    PasswordForgotten: '/forgotten',
};

export const PAGE_CUSTOMER = {
    Reports: '/reports',
    ReportsList: '/reports-list',
    RequestReport: '/request-report',
};

export const PAGE_ADMIN = {
    Users: '/users',
    User: '/user',
};

export const DEFAULT_PAGE = PAGE_GENERAL.Root;
export const DEFAULT_CUSTOMER_PAGE = PAGE_CUSTOMER.ReportsList;
export const DEFAULT_ADMIN_PAGE = PAGE_ADMIN.Users;

const App = () => (
    <main>
        <CheckAuthorization>
            <Switch>
                <Redirect from={PAGE_GENERAL.Root} to={PAGE_GENERAL.Login} exact />

                <SimpleLayout path={PAGE_GENERAL.Login} exact component={LoginPage} />
                <SimpleLayout path={PAGE_GENERAL.Logout} exact component={LogoutPage} />
                <SimpleLayout path={PAGE_GENERAL.PasswordForgotten} exact component={PasswordForgottenPage} />

                <BaseLayout path={PAGE_CUSTOMER.Reports} exact component={ReportsPage} />
                <BaseLayout path={PAGE_CUSTOMER.ReportsList} exact component={RequestReportsListPage} />
                <BaseLayout
                    path={PAGE_CUSTOMER.RequestReport + '/:requestId/:requestName'}
                    component={RequestReportPage}
                />

                <Redirect from={PAGE_ADMIN.Users} to={PAGE_ADMIN.Users + '/1'} exact />
                <AdminLayout path={PAGE_ADMIN.Users + '/:page'} component={AdminUsersPage} />
                <AdminLayout path={PAGE_ADMIN.User + '/:id'} component={AdminUserFormPage} />

                <BaseLayout component={NotFoundPage} />
            </Switch>
        </CheckAuthorization>
    </main>
);

export default App;



// WEBPACK FOOTER //
// ./app/web/src/App.jsx